<script setup lang="ts">
import { computed, ref } from 'vue'
import { Coins, Sparkles } from 'lucide-vue-next'
import type { StreamHudData } from '@/ui/stream-hud'
import type { AppLocale } from '@/i18n/messages'
import { streamMessages } from '@/i18n/stream'

const props = defineProps<{ kind: 'exp' | 'mesos'; data: StreamHudData; locale: AppLocale }>()
const copy = computed(() => streamMessages[props.locale])
const failed = ref(false)
const icon = computed(() => new URL(`/stream-assets/${props.kind}.png`, window.location.href).href)
</script>

<template>
  <section class="adventure-metric" :class="`adventure-metric-${kind}`" :aria-label="copy[kind]" data-stream-measure>
    <div class="sh-kicker" data-stream-measure>
      <span class="sh-icon" aria-hidden="true"><img v-if="!failed" :src="icon" alt="" @error="failed = true"><Sparkles v-else-if="kind === 'exp'" /><Coins v-else /></span>
      <span data-stream-measure>{{ copy[kind] }}</span>
    </div>
    <strong class="sh-value" :class="{ 'sh-exp-value': kind === 'exp' }" :data-stream-exp="kind === 'exp' ? '' : undefined" :data-stream-mesos="kind === 'mesos' ? '' : undefined" data-stream-measure>{{ kind === 'exp' ? data.expRate : data.mesosRate }}</strong>
    <div class="sh-fact" data-tier="3" data-stream-measure><span>{{ kind === 'exp' ? data.expGainedLabel : copy.net }}</span><b data-stream-measure>{{ kind === 'exp' ? data.expGained : data.mesosNet }}</b></div>
    <div v-if="kind === 'exp'" class="sh-fact" data-tier="5" data-stream-measure><span>{{ copy.full }}</span><b data-stream-measure>{{ data.fullDuration }}</b></div>
    <template v-else>
      <div class="sh-fact" data-tier="5" data-stream-measure><span>{{ copy.start }}</span><b data-stream-measure>{{ data.mesosStart }}</b></div>
      <div class="sh-fact" data-tier="5" data-stream-measure><span>{{ copy.balance }}</span><b data-stream-measure>{{ data.mesosBalanceChange }}</b></div>
    </template>
  </section>
</template>
